const sideBar = document.getElementById('side-bar');
document.getElementById('menu-from-side-bar').appendChild(sideBar.cloneNode(true));
const sideBarToggleBtns = document.querySelectorAll('.main-side-bar .sidebar-btnarea .toggle-btn');
sideBarToggleBtns.forEach(item => {
    item.addEventListener('click', e => {
        e.currentTarget.parentNode.parentNode.dataset.open = e.currentTarget.dataset.toggleBrandname;
    });
});

const sideBarToggle = document.querySelectorAll('.main-side-bar .item-top div.toggle');
sideBarToggle.forEach(item => {
    item.addEventListener('click', e => {
        const root = e.currentTarget.parentNode.parentNode;
        root.classList.toggle('open');
        const ul = root.querySelector('ul');
        if(root.classList.contains('open') && ul){
            ul.style.height = 'auto';
            let h = ul.offsetHeight;
            ul.style.height = h + 'px';
            ul.animate(
                {
                    height: [ 0, h + 'px' ]
                },
                {
                    duration: 100,
                }
            );
            ul.style.height = 'auto';
        }else{
            let h = ul.offsetHeight;
            ul.style.height = h + 'px';
            ul.animate(
                {
                    height: [ h + 'px', 0 ]
                },
                {
                    duration: 100,
                }
            );
             ul.style.height = 0;
        }
    });
});

const moveHeaderHeading = document.getElementById('move_header__heading');
const spHeaderMoveArea = document.getElementById('sp-header-move-area');
if(moveHeaderHeading && spHeaderMoveArea){
    spHeaderMoveArea.appendChild(moveHeaderHeading.cloneNode(true));
}

// const spHeaderNavArea = document.getElementById('sp-header-nav-area');
// const spHeaderMoveNavArea = document.getElementById('sp-header-move-nav-area');
// if(spHeaderNavArea && spHeaderMoveNavArea){
//     spHeaderMoveNavArea.appendChild(spHeaderNavArea.content.cloneNode(true));
// }